var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolbarComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 9,
    rx: 0.8,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8l3-3M9 8l2-2M8 11v3M12 14H4",
    stroke: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjEyIiBoZWlnaHQ9IjkiIHJ4PSIwLjgiIHN0cm9rZT0id2hpdGUiLz4KPHBhdGggZD0iTTUgOEw4IDUiIHN0cm9rZT0id2hpdGUiLz4KPHBhdGggZD0iTTkgOEwxMSA2IiBzdHJva2U9IndoaXRlIi8+CjxwYXRoIGQ9Ik04IDExVjE0IiBzdHJva2U9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMiAxNEw0IDE0IiBzdHJva2U9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgToolbarComputer as ReactComponent };